import { useEffect, useState } from "react";

/**
 * returns whether or not the ref's scroll top position is 0.
 * @param {import("react").Ref} ref
 * @returns
 */
const useScrollTop = (ref, callback) => {
  const [scrolltop, setScrolltop] = useState();

  useEffect(() => {
    const current = ref?.current;
    if (!current) return;
    if (!current.onscroll)
      current.onscroll = ({ target: { scrollTop } }) => {
        if (typeof scrollTop === "number") {
          setScrolltop(scrollTop);
          if (typeof callback === "function") callback(scrollTop);
        }
      };
  }, [callback, ref]);

  return scrolltop;
};

export default useScrollTop;
